
/**
 * --- External Imports ---
 */
import { Grid } from "@mui/material";
import { FC } from "react";

/**
 * --- Internal Imports ---
 */
import { Field } from "@ngt/forms-core";
import { CheckboxGroupFormField } from "../../../../api/dtos/dtos";
import { IFormFieldComponentProps } from "../types/FieldTypes";
import FieldErrors from "../utils/FieldErrors";
import FormFieldCheckbox from "./FormFieldCheckbox";
import CheckboxGroupControlLabel from "../labels/CheckboxGroupControlLabel";


/**
 * --- Checkbox Group Component ---
 */
const FormFieldCheckboxGroup: FC<IFormFieldComponentProps<CheckboxGroupFormField>> = ({
    field,
    form
}) => {
    return (
        <CheckboxGroupControlLabel 
            field={field}
            control={
                <>
                    <Field propertyPath={`${form.name}.${field.name}`}>
                        <FieldErrors />
                    </Field>
                    <Grid container>
                        {field.checkboxes?.map(x => (
                            <FormFieldCheckbox
                                key={`${x.id}-${x.fieldType}-checkbox`}
                                field={x}
                                form={form}
                            />
                        ))}
                    </Grid>
                </>
            }
        />
    );
}

export default FormFieldCheckboxGroup;